import { jsx as _jsx } from "react/jsx-runtime";
import { LogoImg } from "../../../assets/logo";
import { useContext } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import styles from "./logo-container.module.css";
export const LogoContainer = ()=>{
    const { logicStore  } = useContext(SharedUiHeaderV2Context);
    const { handleTrackEvent  } = logicStore;
    return /*#__PURE__*/ _jsx("li", {
        className: styles.logoWrapper,
        children: /*#__PURE__*/ _jsx("a", {
            href: "/",
            "aria-label": "cinch homepage",
            onClick: ()=>handleTrackEvent({
                    name: "click",
                    category: "mega menu",
                    label: "cinch logo",
                    action: "button"
                }),
            children: /*#__PURE__*/ _jsx(LogoImg, {})
        })
    });
};
